import axios, { AxiosInstance } from 'axios'

// Базовый URL для API (меняй здесь для переноса на хостинг)
const BASE_URL = 'https://muonline-backend.vercel.app/'
//const BASE_URL = 'http://localhost:3000/'

// Инстанс для запросов с авторизацией
const api: AxiosInstance = axios.create({
	baseURL: BASE_URL,
	timeout: 10000, // Таймаут на запросы (10 секунд)
})

// Инстанс для публичных запросов (без токена)
const publicApi: AxiosInstance = axios.create({
	baseURL: BASE_URL,
	timeout: 10000,
})

// Перехватчик для добавления токена только в api (для авторизованных запросов)
api.interceptors.request.use(
	config => {
		const token = localStorage.getItem('token')
		if (token) {
			config.headers.Authorization = `Bearer ${token}`
		}
		return config
	},
	error => Promise.reject(error)
)

// Публичные запросы (без токена)
export const fetchServerStats = () => publicApi.get('/api/server-stats')

export const fetchTopPlayers = (sortBy: string, sortOrder: string) =>
	publicApi.get('/api/top-players', { params: { sortBy, sortOrder } })

// Запросы, требующие авторизацию (с токеном)
export const fetchProfile = () => api.get('/api/profile')

export const fetchGuilds = () => api.get('/api/characters/guilds')

export const login = (username: string, password: string) =>
	api.post('/api/login', { username, password })

export const register = (data: any) => api.post('/api/register', data)

export const fetchCharacterDetails = (name: string) =>
	api.get(`/api/character/${name}`)

// Экспортируем оба инстанса для кастомных запросов
export { api, publicApi }
